import {NavigationExtras} from "@angular/router";

export class PerBoxModel {
    pageName: string;
    navigationParameter: string;
    personnelCardClass: string;
    dotIconClass: string;
    isSelected: boolean;
    navigationExtras?: NavigationExtras;
    displayOrder: number = 999;
    cardId?: number;
    iconName?: string;
    imageDisplay?: boolean;
    imageSrc?: string;


    constructor(
        pageName: string,
        navigationParameter: string,
        personnelCardClass: string,
        dotIconClass: string,
        cardId: number = null,
        iconName: string = null,
        imageDisplay: boolean = false,
        imageSrc: string = null,
        isSelected: boolean = false,
        navigationExtras: NavigationExtras = null,
    ) {
        this.pageName = pageName;
        this.navigationParameter = navigationParameter;
        this.personnelCardClass = personnelCardClass;
        this.dotIconClass = dotIconClass;
        this.cardId = cardId;
        this.iconName = iconName;
        this.imageDisplay = imageDisplay;
        this.imageSrc = imageSrc;
        this.isSelected = isSelected;
        this.navigationExtras = navigationExtras;
    }
}
